import Vue from 'vue';
import Vuex from 'vuex';
import previewImage from './modules/previewImage';
 
Vue.use(Vuex);
 
const store = new Vuex.Store({
  modules: {
		previewImage
	},
});
 
export default store;